import PropTypes from 'prop-types';
import { get } from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { BarLoader } from '@unite-us/app-components';
import { useMessages } from 'src/components/Notes/queries';
import Note from 'src/components/Notes/Note';
import AddCirclePlusButton from 'common/display/Profile/components/AddCirclePlusButton';
import Pagination from 'src/common/Pagination/Pagination';

const Messages = ({
  onAddNote,
  subject,
  providerId,
  isClientsDrawer,
  showHeader,
  compactBottomSpacing,
}) => {
  const {
    messages,
    response,
    page,
    pageSize,
    setPageSize,
    setPageNumber,
    isLoading,
  } = useMessages({
    subject,
    providerId,
  });

  const paging = get(response, 'data.paging');
  const displayMessages = isClientsDrawer ? messages.slice(0, 3) : messages;
  return (
    <div>
      <div>
        {showHeader && (
          <div className="mb-4 flex justify-end">
            <h2 className="w-9/12">
              Messages
            </h2>
            <div className="w-3/12 flex justify-end">
              <AddCirclePlusButton
                className="text-right"
                id="add-case-message-button"
                labelText="Message Client"
                addHandler={onAddNote}
              />
            </div>
          </div>
        )}
        <div id="messages-container" data-test-element="messages-container">
          {
            isLoading ? (
              <BarLoader className="h-60" size="full" />
            ) : null
          }
          {
            !isLoading && !displayMessages.length ? (
              <div className={
                'bg-dark-fill-blue border border-solid ' +
                'border-dark-border-blue color-grey text-center py-8 px-6 mb-6 rounded'
              }
              >
                No messages with this client.
              </div>
            ) : null
          }
          {
            displayMessages.map((n) => (
              <div className="mb-4" data-test-element={`message-${n.id}`}>
                <Note
                  {...n}
                  duration={n.duration}
                  interactionDate={n.interactionDate}
                  category={n.category}
                  text={n.details.displayMessage}
                  noteType="Message"
                />
              </div>
            ))
          }
          {!isClientsDrawer &&
            (
              <div className={compactBottomSpacing ? 'mb-0' : 'mb-16'}>
                <Pagination
                  pageNumber={page}
                  pageSize={pageSize}
                  totalItemCount={paging.total_count}
                  totalPageCount={paging.total_pages}
                  setPageSize={setPageSize}
                  setPageNumber={setPageNumber}
                />
              </div>
          )}
        </div>
        {!compactBottomSpacing && <div className="connector" />}
      </div>
    </div>
  );
};

Messages.propTypes = {
  subject: PropTypes.string.isRequired,
  onAddNote: PropTypes.func.isRequired,
  providerId: PropTypes.string.isRequired,
  isClientsDrawer: PropTypes.bool,
  showHeader: PropTypes.bool,
  compactBottomSpacing: PropTypes.bool,
};

Messages.defaultProps = {
  isClientsDrawer: false,
  showHeader: true,
  compactBottomSpacing: false,
};

const mapStateToProps = (state, ownProps) => ({
  onAddNote: ownProps.onAddNote,
  providerId: ownProps.providerId,
  subject: ownProps.subject,
  subjectType: ownProps.subjectType,
});

export default connect(mapStateToProps)(Messages);
